/*
 * @Descripttion:
 * @version:
 * @Author: linxi
 * @email: 2194421430@qq.com
 * @Date: 2024-10-18 16:55:09
 * @LastEditors: linxi
 * @LastEditTime: 2025-08-12 14:00:32
 */
import { SearchOutlined } from '@ant-design/icons'
import {
  Button,
  Form,
  Row,
  Select,
  Space,
  Cascader as Cascaded,
  DatePicker,
  Checkbox,
  Input,
  Popover,
  Col,
} from 'antd'
import moment from 'moment'
import React, { ReactElement, useContext, useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { selectInsuranceArray, selectTenantCountyCode } from '../../../../app/applicationSlice'
import { RootDispatch } from '../../../../app/store'
import {
  DateRangeType,
  DateSelect,
} from '../../../../compnents/form/DateSelect'
import {
  DateTimeFormatSimple,
  DateTimeFormatSimpleOnlyOne,
} from '../../../../models/datetime'
import { ThemeContext } from '../../../../theme/ThemeContext'
import styles from './TraceCodeFlow.module.css'
import { FilterIconOutlined } from '../../../../compnents/icons/Icons'

const { Option } = Select

export const Query = (props: {
  exportLoading?: boolean
  loading?: any
  onValueChange: (params: any) => void
  export: () => void
}): ReactElement => {
  const [form] = Form.useForm()

  const [popoverForm] = Form.useForm()

  const theme = useContext(ThemeContext)

  const [open, setOpen] = useState(false)

  const { RangePicker } = DatePicker

  const insuranceArray = useSelector(selectInsuranceArray)

  const dispatch = useDispatch<RootDispatch>()

  const [flag, setFlag] = useState<any>()

  const [dates, setDates] = useState<any>([])

  // useEffect(() => {
  //   form.setFieldsValue({
  //     time: [moment().startOf('day'), moment().endOf('day')],
  //   })
  // }, [])

  const disabledSixMonthDate: any = (current: any) => {
    const tooLate = dates?.[0] && current.diff(dates?.[0], 'months') > 6
    const tooEarly = dates?.[1] && dates?.[1].diff(current, 'months') > 6
    return tooEarly || tooLate
  }

  // 处理日期变化的函数
  const onDateChange = (values: any) => {
    setDates(values)
  }
  return (
    <Form
      form={form}
      onFinish={(values) => {
        if (!values?.timeHead && values?._dateRange == 6) {
          return
        }
        const startTime = moment(values?.timeHead).startOf('day')?.format(
          DateTimeFormatSimpleOnlyOne
        )
        const endTime = moment(values?.timeTail)
          .endOf('day')
          .format(DateTimeFormatSimpleOnlyOne)
        // const startTime =values?.time?.[0]? moment(values?.time?.[0])?.format(
        //   DateTimeFormatSimpleOnlyOne
        // ) : moment()?.format(
        //   DateTimeFormatSimpleOnlyOne
        // )
        // const endTime =values?.time?.[1]? moment(values?.time?.[1])?.format(
        //   DateTimeFormatSimpleOnlyOne
        // ) :moment()?.format(
        //   DateTimeFormatSimpleOnlyOne
        // ) 
        props.onValueChange({
          ...values,
          ...popoverForm.getFieldsValue(),
          param: values?.param ? values?.param : null,
          businessNo: values?.businessNo ? values?.businessNo : null,
          businessType: values?.businessType ? values?.businessType : null,
          medicalUploadStatus: values?.medicalUploadStatus?.toString() ? values?.medicalUploadStatus : null,
          isSplit: values?.isSplit?.toString() ? values?.isSplit : null,
          startTime: startTime,
          endTime: endTime,
          time: undefined,
          timeHead: undefined,
          timeTail: undefined,
        })
      }}
    >
      <Row style={{ marginLeft: 4, marginBottom: 10 }} justify='space-between'>
        <Space>
          <Form.Item name='search' noStyle>
            <Input
              placeholder='患者姓名/药品名/追溯码'
              autoComplete='off'
              prefix={<SearchOutlined />}
              allowClear
              onChange={form.submit}
              style={{
                width: '14rem',
              }}
            />
          </Form.Item>
          <Form.Item name='businessNo' noStyle>
            <Input
              placeholder='就诊id'
              autoComplete='off'
              prefix={<SearchOutlined />}
              allowClear
              onChange={form.submit}
              style={{
                width: '8.6rem',
              }}
            />
          </Form.Item>
          {insuranceArray &&
            insuranceArray.length !== 0 &&
            (
              <Form.Item name='insuranceCode' noStyle>
                <Select
                  placeholder='险种类型'
                  style={{ width: '8.6rem' }}
                  allowClear
                  onChange={(() => {
                    form.submit()
                  })}
                >
                  <Select.Option value={''}>全部</Select.Option>
                  <Select.Option value={'ZIFEI'}>自费</Select.Option>
                  {insuranceArray.map((v) => (
                    <Select.Option value={v.insuranceCode} key={v.id}>
                      {v.insuranceName}
                    </Select.Option>
                  ))}
                </Select>
              </Form.Item>
            )}
          <Form.Item name='businessType' label='' noStyle>
            <Select
              allowClear
              placeholder='业务名称'
              style={{
                width: '8.6rem',
              }}
              onChange={(e) => {
                setFlag(e)
                form.submit()
              }}
            >
              <Option value={1}>发药/退药上传</Option>
              <Option value={2}>入库上传</Option>
            </Select>
          </Form.Item>

          <Form.Item name='medicalUploadStatus' label='' noStyle>
            <Select
              allowClear
              placeholder='医保上传状态'
              style={{
                width: '9rem',
              }}
              onChange={form.submit}
            >
              {flag == 1 ? (
                <>
                  <Option value={0}>未上传</Option>
                  <Option value={1}>发药已上传</Option>
                  <Option value={2}>退药已上传</Option>
                </>
              ) : flag == 2 ? (
                <>
                  <Option value={0}>未上传</Option>
                  <Option value={1}>入库已上传</Option>
                </>
              ) : (
                <>
                  <Option value={0} disabled>
                    请先选择业务类型
                  </Option>
                </>
              )}
            </Select>
          </Form.Item>
          <Form.Item name='isSplit' label='' noStyle>
            <Select
              allowClear
              placeholder='是否拆零'
              style={{ width: '7rem' }}
              onChange={form.submit}
            >
              <Option value={1}>是</Option>
              <Option value={0}>否</Option>
            </Select>
          </Form.Item>
          {/* <Form.Item name='isRepeat' label='' noStyle>
            <Select allowClear placeholder='是否重复'>
              <Option value={1}>是</Option>
              <Option value={0}>否</Option>
            </Select>
          </Form.Item> */}
          <DateSelect
            allowClear={false}
            style={{ width: '6rem' }}
            labelPrefix=''
            namePrefix='time'
            initialValue={DateRangeType.Today}
            onChange={() => form.submit()}
            onCalendarChange={(v) => {
              onDateChange(v)
            }}
            disabledDate={disabledSixMonthDate}
          />
          {/* <Popover
            visible={open}
            overlayClassName={styles.formQueryPopover}
            content={
              <>
                <Form
                  form={popoverForm}
                  onFinish={(val) => {
                    form.submit()
                    setOpen(false)
                  }}
                >
                  <Row>
                    <Col
                      className={styles.formQueryLabel}
                    >
                      批次号：
                    </Col>
                    <Col>
                      <Form.Item label='' name='batchNo'>
                        <Input placeholder='请输入批次号' style={{ width: '240px' }}></Input>
                      </Form.Item>
                    </Col>
                  </Row>
                  <Row
                    style={{
                      height: '1px',
                      background: '#f0f0f0',
                      marginTop: '10px',
                    }}
                  ></Row>
                  <Space
                    style={{
                      display: 'flex',
                      justifyContent: 'end',
                      marginTop: '10px',
                    }}
                  >
                    <Button
                      size='middle'
                      type={'ghost'}
                      onClick={() => {
                        setOpen(false)
                      }}
                    >
                      取消
                    </Button>
                    <Button size='middle' type='primary' htmlType='submit'>
                      确定
                    </Button>
                  </Space>
                </Form>
              </>
            }
            title=''
            trigger='click'
            placement='bottom'
            onVisibleChange={(v) => {
              setOpen(v)
            }}
          >
            <Form.Item name='' initialValue={'筛选'} noStyle>
              <Button
                style={{
                  color: theme.tc2,
                  width: '78px',
                  textAlign: 'left',
                  // overflow: 'hidden',
                  // textOverflow: 'ellipsis',
                }}
                icon={
                  <FilterIconOutlined
                    style={{
                      width: '14px',
                      height: '14px',
                      position: 'relative',
                      top: 2,
                      left: -2,
                      color: '#666',
                    }}
                  />
                }
                onClick={() => {
                  setOpen(true)
                }}
              >
                筛选
              </Button>
            </Form.Item>
          </Popover> */}
          {/* <Form.Item name='time' noStyle>
            <RangePicker
              format={DateTimeFormatSimple}
              style={{ width: '16em' }}
              allowClear={false}
              disabledDate={disabledSixMonthDate}
            />
          </Form.Item> */}
          <Button
            loading={props?.loading}
            type='primary'
            onClick={() => {
              form.submit()
            }}
          >
            查询
          </Button>
        </Space>
        <Space>
          <Button
            loading={props?.exportLoading}
            type='primary'
            onClick={() => {
              props?.export()
            }}
          >
            导出
          </Button>
        </Space>
      </Row>
    </Form>
  )
}
